import styled, { css } from 'styled-components';
import { fonts, colors } from 'stylesheets';

import { NavLink as _NavLink, Link } from 'react-router-dom';

import { Button } from 'triider-components';

export const NavLink = styled(_NavLink)`
  ${({ disabled }) => disabled
    && css`
      cursor: not-allowed;
      opacity: 0.5;
    `}
`;

export const StyledLink = styled(Link)`
  display: flex;
  justify-content: flex-start;
  align-items: center;
  height: 100%;
  width: 200px;
`;

export const DownloadButton = styled(Button)`
  margin-left: auto;
  width: auto;
  height: 30px;
  font-size: 10px;
  border-radius: 3px;
  margin-right: 25px;

  & > img {
    margin-right: 5px;
  }
`;

export const OrderDetails = styled.div`
  padding-left: 65px;
  margin-top: 140px;
`;

export const ServiceName = styled.div`
  display: flex;
  justify-content: center;
  padding-right: 200px;
  flex: 1;
  font-family: 'Roboto', sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 24px;
  color: #565656;

  span{
    color: ${({ isAdmin }) => (isAdmin ? '#3E81F7' : '#565656')};
  }
`;

export const Label = styled.span`
  font-size: 10px;
  padding: 4px 10px 3px;
  color: ${colors.white};
  margin: 0 15px;
  max-width: max-content;
  background: ${({ color }) => colors[color]};
`;

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 100%;
  padding-left: 40px;
  padding-right: 40px;
`;

export const Header = styled.div`
  display: flex;
  margin-top: 20px;
  margin-bottom: 25px;
  align-items: center;
  flex: 1;
  height: 55px;
  border-radius: 5px;
  border: 1px solid #eeeeee;
  background: ${colors.white};
  
  img {
    width: 20px;
    height: 20px;
    margin: 0 10px 0 10px;
  }
  .label-back {
    font-family: 'Roboto', sans-serif;
    font-style: normal;
    font-weight: 500;
    font-size: 16px;
    line-height: 20px;
    color: #F07E31;
    padding: 15px;
  }
  p {
    font: 14px 'Roboto', sans-serif;
    text-transform: uppercase;
    text-align: center;
    margin-top: -16px;
  }
`;

export const DetailsCard = styled.div`
  min-height: 650px;
  height: auto;
  background: ${colors.white};
  border-radius: 5px;
  font-weight: 500;
  border: 1px solid #eeeeee;
  padding: 20px 0 20px 25px;
  display: flex;
  width: 100%;
  flex-direction: column;
`;

export const Tabs = styled.div`
  border-bottom: 2px solid ${colors.greyLighter2};
  position: relative;
  display: flex;
  align-items: flex-start;
  height: 40px;
  margin-bottom: 15px;

  a {
    position: relative;
    top: 2px;
    font: 14px 'Roboto', sans-serif;
    line-height: 16px;
    color: ${colors.greyDark};
    display: inline-block;
    text-decoration: none;
    padding: 5px 20px 0px;
    height: 100%;
    &.active {
      border-bottom: 2px solid ${colors.primary};
      font-weight: bold;
      color: ${colors.primary};
    }
  }
`;

export const WrapperTab = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100% !important;
  position: relative;
`;

export const ContentTab = styled.div`
    display: flex;
    flex-direction: column;
    width: calc(100% - 70px);
    margin-right: 15px;
`;
